<template>
    <div class="grid-fitted">
        <div class="grid-item grid-item-full">
            <r-input :props="$props" @key-down="keyDown" @key-press="keyUp" v-model="typedInput" ref="typedInput"/>
        </div>
        <div class="grid-item grid-item-full">
            <suggestion-picker
                ref="suggestionPicker"
                :providers="suggestionProviders"
                @input="suggestionSelected"/>
        </div>
    </div>
</template>

<script>
    import SuggestionPicker from './suggestion-picker';

    const spaceRegex = /(\s+)/g;

    export default {
        components: {
            SuggestionPicker,
        },
        name: 'typeahead-input',
        props: {
            suggestionProviders: Array,
        },
        data() {
            return {
                typedInput: '',
            };
        },
        methods: {
            keyDown(event) {
                if (this.$refs.suggestionPicker.isActionKey(event)) {
                    event.preventDefault();
                }
            },
            keyUp(event) {
                if (this.$refs.suggestionPicker.isActionKey(event)) {
                    this.$refs.suggestionPicker.keyUp(event);
                } else {
                    this.$refs.suggestionPicker.checkForSuggestions(this.typedInput);
                }
            },
            suggestionSelected({resource, isPartial, wordIndex}) {
                const wordsAndSpaces = this.typedInput.split(spaceRegex);
                wordsAndSpaces[wordIndex] = `${resource}${isPartial ? '' : ' '}`;
                this.typedInput = wordsAndSpaces.join('');
                if (isPartial) {
                    this.$refs.suggestionPicker.checkForSuggestions(this.typedInput);
                }
                this.$refs.typedInput.getFocus();
            },
        },
    };
</script>
